import React from 'react';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiSend, FiTwitter, FiLinkedin, FiFacebook, FiYoutube, FiHeart } = FiIcons;

const Footer = () => {
  const footerColumns = [
    {
      title: "Product",
      links: [
        { name: "Features", href: "#features" },
        { name: "Pricing", href: "#pricing" },
        { name: "Integrations", href: "#" },
        { name: "Roadmap", href: "#" },
        { name: "Changelog", href: "#" }
      ]
    },
    {
      title: "Resources",
      links: [
        { name: "Blog", href: "#" },
        { name: "Tutorials", href: "#" },
        { name: "Help Center", href: "#" },
        { name: "API Docs", href: "#" },
        { name: "Status Page", href: "#" }
      ]
    },
    {
      title: "Company",
      links: [
        { name: "About", href: "#" },
        { name: "Contact", href: "#" },
        { name: "Careers", href: "#" },
        { name: "Brand Kit", href: "#" },
        { name: "Affiliate Program", href: "#" }
      ]
    },
    {
      title: "Legal",
      links: [
        { name: "Privacy Policy", href: "#" },
        { name: "Terms of Service", href: "#" },
        { name: "Cookie Policy", href: "#" },
        { name: "GDPR Compliance", href: "#" },
        { name: "Security", href: "#" }
      ]
    }
  ];

  const socialLinks = [
    { icon: FiTwitter, href: "https://twitter.com/postifyr", label: "Twitter" },
    { icon: FiLinkedin, href: "https://linkedin.com/company/postifyr", label: "LinkedIn" },
    { icon: FiFacebook, href: "https://www.facebook.com/postifyr", label: "Facebook" },
    { icon: FiYoutube, href: "https://youtube.com/@postifyr", label: "YouTube" }
  ];

  return (
    <footer className="bg-brand-gray-50 text-gray-600 pt-20 pb-10 px-4 sm:px-6 lg:px-8 border-t border-gray-200">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8 mb-16">
          {footerColumns.map((column, index) => (
            <div key={index}>
              <h3 className="text-brand-navy font-bold mb-6">
                {column.title}
              </h3>
              <ul className="space-y-4">
                {column.links.map((link, linkIndex) => (
                  <li key={linkIndex}>
                    <a href={link.href} className="text-gray-500 hover:text-brand-teal transition-colors text-sm">
                      {link.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row justify-between items-center pt-8 border-t border-gray-200 gap-6">
          {/* Logo and Copyright */}
          <div className="flex items-center space-x-2">
            <SafeIcon icon={FiSend} className="text-xl text-brand-teal transform rotate-45" />
            <span className="text-sm font-bold text-brand-navy">© 2025 Postifyr. All rights reserved.</span>
          </div>

          <div className="text-sm flex items-center gap-1">
            Made with <SafeIcon icon={FiHeart} className="text-red-500 fill-current" /> for entrepreneurs
          </div>

          {/* Social Links */}
          <div className="flex items-center space-x-6">
            {socialLinks.map((social, index) => (
              <a 
                key={index} 
                href={social.href} 
                className="text-gray-400 hover:text-brand-teal transition-colors"
                aria-label={social.label}
              >
                <SafeIcon icon={social.icon} className="text-xl" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;